import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  holder: {
    display: 'flex',
    alignItems: 'center'
  },

  root: {
    position: 'relative',
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    maxHeight: '61px',
    backgroundColor: 'white',
    transition: 'background-color 0.75s',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#F6F7F8'
    }
  },

  type: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '4px',
    height: '61px',
    backgroundColor: 'transparent'
  },

  avatarHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '0',
    marginRight: '0',
    minWidth: '60px',
    height: '61px',

    '& .MuiIconButton-root:hover': {
      backgroundColor: '#EBEEEF'
    }
  },

  contentRoot: {
    display: 'flex',
    flex: '1',

    [theme.breakpoints.down('md')]: {
      marginRight: '1rem'
    }
  },

  contentBlock: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
      width: '98%'
    }
  },

  contentTitle: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2px',
    marginTop: '0.5rem'
  },

  contentName: {
    overflow: 'hidden',
    maxWidth: '7rem',
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#323436'
  },

  contentFaded: {
    opacity: '0.35'
  },

  content: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '11rem',
    height: '40px',
    color: '#7F8487',
    fontSize: theme.size.sm,
    marginTop: '4px'
  }
}))

export default useStyles
